import { LocaleType } from '../../constants/localeConstants';
import { DateDisplayFormat, DateParts } from '../../types';
import { createUtcStartOfDay } from '../internal/temporalDate/dateBuilder';
import { getValidLocale } from '../internal/getValidLocale';
import { formatNativeDate } from './formatNativeDate';

/**
 * Formats a raw date input to a localized UI string using a specified format.
 *
 * @param input - Any raw date input (string, Date, number) to format.
 * @param format - The display format: e.g., 'short', 'condensed', etc.
 * @param locale - Optional BCP 47 locale string.
 * @returns Formatted string if valid date input, otherwise undefined.
 */
export function formatDateParts(
  input: DateParts,
  format: DateDisplayFormat,
  locale?: LocaleType,
  timezone?: string,
): string {
  const date = createUtcStartOfDay(input);
  if (!date) return input.toString();
  const validLocale = getValidLocale(locale);
  return formatNativeDate(date, format, validLocale, timezone);
}
